import { useState } from 'react';
import api from '../utils/api';
import { useConfirm, useToast } from '../context/FeedbackContext';

/**
 * Admin-only "Void" action for an AR invoice. Void is the only status that
 * is ever set by hand - draft/sent/partial/paid all follow from submission
 * and verified payments. The server refuses to void an invoice that has
 * payments recorded, and re-opens the invoice's PO so it can be billed again.
 */
export default function VoidArInvoiceButton({ invoice, onVoided, className = 'btn btn-sm btn-secondary' }) {
  const confirm = useConfirm();
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!invoice || invoice.status === 'void') return null;

  async function handleVoid() {
    const ok = await confirm({
      title: `Void invoice ${invoice.invoice_number}?`,
      message: 'The invoice stays on record but is marked Void and excluded from AR totals. If it was generated from a PO, that PO goes back to Open so it can be invoiced again.\n\nThis can only be undone by an administrator in the database.',
      confirmLabel: 'Void invoice',
      danger: true,
    });
    if (!ok) return;
    setBusy(true);
    try {
      await api.put(`/ar-invoices/${invoice.id}`, { status: 'void' });
      toast(`Invoice ${invoice.invoice_number} voided`, 'success');
      if (onVoided) onVoided();
    } catch (e) {
      toast(e.response?.data?.error || 'Could not void invoice', 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <button className={className} onClick={handleVoid} disabled={busy} style={{ color: 'var(--danger-text)' }}>
      {busy ? 'Voiding…' : '⊘ Void'}
    </button>
  );
}
